<template>
  <gradient-background>
    <center-card>
      <template v-slot:card-title>
        {{$t('login.title')}}
      </template>
      <template v-slot:card-body>
        <login-form/>
      </template>
    </center-card>
  </gradient-background>
</template>

<script>
  import GradientBackground from '../layouts/general/GradientBackground.vue';
  import CenterCard from '../layouts/cards/CenterCard.vue';
  import LoginForm from '../components/auth/LoginForm.vue';

  export default {
    components: {
      GradientBackground,
      CenterCard,
      LoginForm,
    },
  };
</script>
